// extracted by mini-css-extract-plugin
export var container = "_8o-1";
export var cornerButtonContainer = "_8o-5";
export var disabled = "_8o-2";
export var fileContainer = "_8o-4";
export var hiddenInput = "_8o-3";
export var widthContainer = "_8o-0";